export default __webpack_public_path__ + "static/media/logo.341f2726.svg";